import React, { useEffect, useState } from "react";
import "./style.scss";
import { closeLoading, showLoading } from "../../redux/actions/appAction";
import { useDispatch } from "react-redux";
import { listGuestsApi } from "../../utils/api";
import Dropdown from "../../components/Dropdown";
import {
  closeNotification,
  showNotification,
} from "../../redux/actions/notificationAction";
import { capitalizeFirstChar } from "../../utils/general";

function Main() {
  const dispatch = useDispatch();
  const [guests, setGuests] = useState({});
  const [status, setStatus] = useState({ label: "All", value: "" });
  const [side, setSide] = useState({ label: "All", value: "" });
  const [category, setCategory] = useState({ label: "All", value: "" });
  const [babyChair, setBabyChair] = useState({ label: "All", value: "" });
  const [vegetarian, setVegetarian] = useState({ label: "All", value: "" });
  const [statusList, setStatusList] = useState([
    { label: "All", value: "" },
    { label: "Pending", value: "pending" },
    { label: "Rejected", value: "rejected" },
    { label: "Accepted", value: "accepted" },
    { label: "Submitted", value: "submitted" },
  ]);
  const [sideList, setSideList] = useState([
    { label: "All", value: "" },
    { label: "Doris", value: "Doris" },
    { label: "Qwan", value: "Qwan" },
  ]);
  const [categoryList, setCategoryList] = useState([
    { label: "All", value: "" },
    { label: "Business Partner", value: "business_partner" },
    { label: "Family", value: "family" },
    { label: "Friend", value: "friend" },
    { label: "Company", value: "company" },
  ]);
  const [yesNoList, setYesNoList] = useState([
    { label: "All", value: "" },
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ]);

  const guestCategory = {
    family: "Family",
    friend: "Friend",
    business_partner: "Business Partner",
    company: "Company",
  };

  useEffect(() => {
    dispatch(showLoading());

    getAllGuests().then((res) => {
      const { Items } = res.data;

      const data = listGuestsByTable(Items);

      setGuests(data);

      dispatch(closeLoading());
    });
  }, [side, status, category, vegetarian, babyChair]);

  const getAllGuests = async () => {
    try {
      const guestList = await listGuestsApi({
        status: status.value,
        side: side.value,
        category: category.value,
        vegetarian: vegetarian.value,
        babyChair: babyChair.value,
      });

      return guestList;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const listGuestsByTable = (guestList) => {
    const data = {};

    guestList.forEach((item) => {
      if (data[item.category]) {
        data[item.category] = [...data[item.category], item];
      } else {
        data[item.category] = [item];
      }
    });

    return data;
  };

  const showRemarks = (remarks) => {
    dispatch(
      showNotification(
        "Remarks",
        remarks,
        <button
          type="button"
          className="btn submit__btn"
          onClick={() => dispatch(closeNotification())}
        >
          Close
        </button>
      )
    );
  };

  return (
    <div className="main-page">
      <div className="main-page__dropdowns">
        <div className="side-dropdown">
          <Dropdown
            options={sideList}
            value={side}
            onSelect={(selected) => {
              setSide(selected);
            }}
          />
        </div>
        <div className="status-dropdown">
          <Dropdown
            options={statusList}
            value={status}
            onSelect={(selected) => {
              setStatus(selected);
            }}
          />
        </div>
        <div className="category-dropdown">
          <Dropdown
            options={categoryList}
            value={category}
            onSelect={(selected) => {
              setCategory(selected);
            }}
          />
        </div>
        <div className="nested">
          <div className="vegetarian-dropdown">
            <span>Vegetarian</span>
            <Dropdown
              options={yesNoList}
              value={vegetarian}
              onSelect={(selected) => {
                setVegetarian(selected);
              }}
            />
          </div>
          <div className="baby-seat-dropdown">
            <span>Baby Chair</span>
            <Dropdown
              options={yesNoList}
              value={babyChair}
              onSelect={(selected) => {
                setBabyChair(selected);
              }}
            />
          </div>
        </div>
      </div>
      <div className="main-page__content">
        {Object.keys(guests).map((cat, i) => (
          <div className="main-page__table" key={i}>
            <h2 className="title">{guestCategory[cat]}</h2>
            <table>
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Pax</th>
                  <th>Vegetarian</th>
                  <th>Pax of Vegetarian</th>
                  <th>Baby Chair</th>
                  <th>Contact</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {guests[cat].map((item, j) => (
                  <tr key={j}>
                    <td>{item.username}</td>
                    <td>{item.name}</td>
                    <td>{capitalizeFirstChar(item.status)}</td>
                    <td>{item.pax}</td>
                    <td>
                      {item.vegetarian === "Y"
                        ? "Yes"
                        : item.vegetarian === "N"
                        ? "No"
                        : ""}
                    </td>
                    <td>{item.vegetarianPax}</td>
                    <td>
                      {item.babyChair === "Y"
                        ? "Yes"
                        : item.babyChair === "N"
                        ? "No"
                        : ""}
                    </td>
                    <td>{item.contactNo}</td>
                    <td>
                      {item.remarks && item.remarks.trim() !== "" && (
                        <div
                          className="remarks-btn"
                          onClick={() => showRemarks(item.remarks)}
                        >
                          <i className="bi bi-eye-fill" />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Main;
